export default class RestProxyError extends Error {
  public status: number
  protected statusText: string

  constructor(response: Response) {
    super()
    this.status = response.status
    this.statusText = response.statusText
    this.message = `Error communicating with REST Proxy: ${this.statusText} [${this.status}]`
  }
}
